import ReactDOM from 'react-dom'
import AuteurContainer from './AuteurContainer.jsx'
import thunkMiddleware from 'redux-thunk'
import createLogger from 'redux-logger'
import { createStore, applyMiddleware } from 'redux'
import { Provider } from 'react-redux';
import auteur_reducer from './reducers/auteur.js'

let initState ;

if (window.__PRELOADED_STATE__){
    initState = window.__PRELOADED_STATE__;
} else {
    initState = {
    'aid' : window.aid, 
    'auteur1' : window.auteur1,
    'date1': window.date1 == 0 ? null : window.date1, 'date2' : window.date2 == 0 ? null : window.date2, 
    'loading': false,
    'processing': false, 
    'loginok' : window.loginok,
    'error': null, 
    'livres': [],
     liens : [],
     bio : null,
     biblio: null,
     route : undefined // will be deducted from the url
    };    
}

let middlewares = [thunkMiddleware];

if (process.env.NODE_ENV !== 'production'){

    middlewares = [...middlewares,createLogger()];
}

const store = createStore(
    auteur_reducer,
    initState,
    applyMiddleware(...middlewares)
);


$( document ).ready(function(){
    if (document.getElementById('loading')){
        document.getElementById('loading').className='hidden';
    }
    main()
});


/*
import { fetchAuteurLiens,  saveAuteurLien, hideAuteurLien} from './actions/auteur.js';

main = function(){
    store.dispatch(fetchAuteurLiens(aid))
     .then(()=>{
        let l = store.getState().liens[0];
        console.log(l);
        l.ltitle='Site de JP Toussaint';
        l.ldesc ='Un peu de tout'
        store.dispatch(saveAuteurLien(aid,l))
        .then(()=>{
            store.dispatch(hideAuteurLien(aid,l.id)).then(()=>{
                    console.log(store.getState().liens);
                })
            })
     });
}

*/
function main(){
    ReactDOM.render(
        <Provider store={store}>
            <AuteurContainer  />
        </Provider>,
     document.getElementById('react_content'));
}




// WEBPACK FOOTER //
// ./auteur/auteur.js